import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { IDeleteAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { removeExternalContentAction } from '../contentActions/RemoveExternalContentAction';
import { selectCatalogingOnSiteEnabled } from '../selectors/CatalogSelectors';

export const RemoveExternalContentEntityAction: IEntityAction<IContentInfo, IDeleteAction> = {
  name: EntityActionNames.RemoveExternalContent,
  translateName: Messages.remove_action,
  isVisible: (_, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.removeExternalContentEnabled,
  isClickable: (availableActions: IDeleteAction) => !!(availableActions && availableActions.del),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('removeExternalContent was called without exactly one item');
    }

    const item = items[0];

    switch(item.contentType) {
      case 'database':
        return removeExternalContentAction(item as IContentInfo<'database'>);
      case 'table':
        return removeExternalContentAction(item as IContentInfo<'table'>);
      case 'databaseWithCrass':
        return removeExternalContentAction(item as IContentInfo<'databaseWithCrass'>);
      case 'tableWithCrass':
        return removeExternalContentAction(item as IContentInfo<'tableWithCrass'>);
      default:
        throw new Error('removeExternalContent is only valid for database and table content types');
    }
  }
};
